export default __webpack_public_path__ + "static/media/fragile_bone_shard.44347534.png";